import config from 'constants/config'

/** @deprecated */
export function getBusinessTravellerSelectEnabled(businessAccount?: App.BusinessTraveller.CurrentBusinessAccount): boolean {
  return (
    config.businessTraveller.currentAccountMode === 'business' &&
    businessAccount?.employee?.roles?.some(role => ['BUSINESS_ADMIN', 'BUSINESS_MANAGER'].includes(role))) ?? false
}
